import { render } from "./AdminUserCreationScreen.vue?vue&type=template&id=25716cb8&scoped=true"
import script from "./AdminUserCreationScreen.vue?vue&type=script&lang=js"
export * from "./AdminUserCreationScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=25716cb8&lang=scss&scoped=true"
import "./AdminUserCreationScreen.vue?vue&type=style&index=1&id=25716cb8&lang=scss&scoped=true"

import exportComponent from "/var/www/html/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25716cb8"]])

export default __exports__